/**
 *Created by jmmartinez on 20/05/22
 * 06/06/2022 v.1.1  Modificado keyPress para usar la función transformadorCadenaFechaHoraToCadenaYTimestamp
 *                   Añadido onBlur
 * 01/09/2020 v.1.2  Añadido botón para mostrar el DateTimePicker.
 * 02/09/2022 v.1.3  Modificado getDerivedStateFromProps para que solo se modifique si prevState.tsValor == 0
 * 07/09/2022 V.1.4  Añadida propiedad para poner hora actual al elegir fecha.
 *                   Botón de calendario conmura mostrar Calendario.
 *                   Cierre de calendario al pinchar en texto
 *                   Creada función para modificar fecha imperativamente desde otro componente: modificarTsFecha
 *
 * 19/10/2022 v.1.5  En el metodo procesarContenido, si al llamar a transformadorCadenaFechaHoraToCadenaYTimestamp obtenemos null,
 *                      asignamos la fecha y hora actual.
 * 20/10/2022 v.1.6  Añadimos la propiedad iniciarConFechaActual
 *                   En el constructor iniciamos la fecha y hora según propiedades.
 * 04/12/2023 v.1.7 Creada la función callOnChange.-
 * 14/12/2023 v.1.8 Añadida llamada a props.onChange en el método changeDateTime.
 *                  En getDerivedStateFromProps comentada la condición && prevState.tsValor == 0 para que se actualice al modificar el valor
 *                                              añadida la condición && nextProps.tsValor !== 0 para que cuando no hay parametro no se inicie vacío-
 * */

import React from 'react'
import PropTypes from 'prop-types';

import {FormGroup, InputGroup, Position, Button} from "@blueprintjs/core";
import {
    getFormattedDateFromTimestamp, getFormattedDateTimeFromTimestamp, getFormattedDateTimeFromDate,
    getStringFromTime, getFormattedDateTimeNow, getDateTimeFromFormattedString,
    getTimestampFromNowSinHora, getTimestampFromNow,
} from "../utils/DateUtils";
import {transformadorCadenaFechaHoraToCadenaYTimestamp} from "../utils/Transformadores";
import DateTimePicker from "../../blueprint/DateTimePicker";


class FechaCadenaInput extends React.Component {

    constructor(props) {
        super(props)

        //console.log("XXXX FechaCadenaInput - Constructor");
        //console.log("props.tsValor: ", props.tsValor);

        let sValor= "";
        let tsValor;

        if (props.tsValor) {
            tsValor= props.tsValor;
            if (props.conHora)
                sValor = getFormattedDateTimeFromTimestamp(tsValor);
            else
                sValor = getFormattedDateFromTimestamp(tsValor);
        }
        else{
            if (props.iniciarConFechaActual && Boolean(props.iniciarConFechaActual)){
                if (props.conHora) {
                    if (props.completarHoraActual)
                        tsValor= getTimestampFromNow();
                    else
                        tsValor= getTimestampFromNowSinHora();
                    sValor = getFormattedDateTimeFromTimestamp(tsValor);
                }
                else {
                    tsValor= getTimestampFromNowSinHora();
                    sValor = getFormattedDateFromTimestamp(tsValor);
                }
                //props.onChange && props.onChange(tsValor); //ERa bueno
            }
        }

        //console.log("tsValor: ", tsValor);
        //console.log("sValor: ", sValor);

        this.state = {
            tsValor: tsValor,
            sValor: sValor,
            mostrarDateTime: false,
        }
        //console.log("tsValor: ", tsValor);
        //console.log("sValor: ", sValor);
    }



    gettsValor= () => {
        const{tsValor} = this.state;
        return tsValor;
    }

    callOnChange= () => {
        const {tsValor} = this.state;
        const {onChange} = this.props;

        //console.log("FECHACADENAINPUT - CallOnChange")
        //console.log("tsValor: ", tsValor);
        //console.log("onChange: ", onChange);
        onChange && onChange(tsValor);
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){

        //console.log("FECHACADENAINPUT --  GETDERIVEDSTATEFROMPROPS ")
        //console.log("nextProps: ", nextProps);
        //console.log("prevState: ", prevState);

        const newState = {};
        if( nextProps.tsValor !== 0 && nextProps.tsValor !== prevState.tsValor /* && prevState.tsValor == 0*/){
            newState.tsValor= nextProps.tsValor;
            let sValor= "";
            if (nextProps.conHora)
                sValor= getFormattedDateTimeFromTimestamp(nextProps.tsValor);
            else
                sValor= getFormattedDateFromTimestamp(nextProps.tsValor);
            newState.sValor= sValor;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onChange= (newValue) => {
        this.setState({sValor: newValue});
    }

    keyPress= (target) =>{
        const {sValor} = this.state;
        const {onChange, tabOrderManager, conHora, id} = this.props;
        if(target.charCode===13){
            this.procesarContenido();
        }
    }

    /*
    //Formato esperado de entrada dd/mm/yyyy hh:mm:ss
export const getDateTimeFromFormattedString = (dateStr) => {
     */

    procesarContenido= () => {
        //console.log("FECHA CADENA INPUT");
        const {sValor} = this.state;
        const {onChange, tabOrderManager, conHora, id, completarSegundosAleatorios} = this.props;
        //console.log("sValor: ", sValor);
        //console.log("conHora: ", conHora);
        //console.log("completarSegundosAleatorios: ", completarSegundosAleatorios);
        let resultado= transformadorCadenaFechaHoraToCadenaYTimestamp(sValor, conHora, completarSegundosAleatorios);
        if (!resultado){
            let newCadenaFechaHora= getFormattedDateTimeNow();
            resultado= {
                tsFecha: getDateTimeFromFormattedString(newCadenaFechaHora).getTime(),
                sFecha: newCadenaFechaHora,
            };
        }
        //console.log("resultado: ", resultado);

        this.setState({tsValor: resultado.tsFecha, sValor: resultado.sFecha});
        onChange && onChange(resultado.tsFecha);
        if(tabOrderManager){
            tabOrderManager.setFocusSiguiente(id);
        }
    }

    //newValor es un Date
    changeDateTime= (dtValor) => {
        const{completarHoraActual, onChange} = this.props;
        let tsValor= dtValor.getTime();
        let sValor= getFormattedDateFromTimestamp(tsValor);
        if (completarHoraActual && Boolean(completarHoraActual)){
            sValor+= " " + getStringFromTime(new Date());
        }

        const {id, tabOrderManager} = this.props
        if (tabOrderManager){
            let ref= tabOrderManager.getRef(id);
            if (ref)
                ref.current.focus();
        }

        this.setState({mostrarDateTime: false, sValor: sValor, tsValor: tsValor}, () => {
            onChange && onChange(tsValor);
        });
    }

    onClick= () => {
        this.setState({mostrarDateTime: false});
    }
    onMostrarDateTimeClick= () => {
        const {mostrarDateTime} = this.state;
        let newMostrarDateTime= mostrarDateTime == null ? true : !mostrarDateTime;
        this.setState({mostrarDateTime: newMostrarDateTime});

    }

    modificarTsFecha= (newTsFecha) => {
        const {conHora} = this.props;
        let sValor= "";
        if (conHora)
            sValor= getFormattedDateTimeFromTimestamp(newTsFecha);
        else
            sValor= getFormattedDateFromTimestamp(newTsFecha);
        this.setState({tsValor: newTsFecha, sValor: sValor});
    }

    render() {
        const {tsValor, sValor, mostrarDateTime} = this.state;
        const {id, titulo, icon, conHora, obligatorio, readOnly, tabOrderManager} = this.props;
        let bObligatorio= Boolean(obligatorio);
        let mostrarHora= (typeof conHora === 'boolean' && conHora === true);
        let key= "fg_" + id;

        //console.log("FECHACADENAINPUT  RENDER ----");
        //console.log("tsValor: ", getFormattedDateTimeFromTimestamp(tsValor));
        //console.log("sValor: ", sValor);

        return(
            <FormGroup key={key} label= {titulo} labelFor={id} labelInfo={obligatorio ? "*" : ""}>
                <div className="selectorlista">
                    <div className="selectorlista_input">
                        <InputGroup
                            id= {id}
                            placeholder= {titulo}
                            value={sValor ? sValor : ""}
                            onKeyPress={(target) => {this.keyPress(target)}}
                            onChange={ (event) => this.onChange(event.target.value)  }
                            readOnly={readOnly ? readOnly : false }
                            inputRef={ id && tabOrderManager ? tabOrderManager.getRef(id) : null }
                            onBlur={this.procesarContenido}
                            onClick={this.onClick}
                        />
                    </div>
                    <Button icon="time" className="selectorlista_boton" onClick={this.onMostrarDateTimeClick}/>
                </div>
                {Boolean(mostrarDateTime) &&
                <DateTimePicker conHora={conHora} onChange={this.changeDateTime} /*valor={tsValor}*//>
                }
            </FormGroup>
        );
    }

}


FechaCadenaInput.propTypes = {
    id: PropTypes.string,
    titulo: PropTypes.string,
    obligatorio: PropTypes.bool,
    readOnly: PropTypes.bool,
    icon: PropTypes.string,
    conHora: PropTypes.bool,
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    tsValor: PropTypes.number,  //Entra el valor en formato Timestamp
    tabOrderManager: PropTypes.object,
    completarSegundosAleatorios: PropTypes.bool,
    completarHoraActual: PropTypes.bool,
    iniciarConFechaActual: PropTypes.bool,

}

export default FechaCadenaInput

